export default "__VITE_ASSET__fQo7dN8g__"